import { FCC } from "@/types/common";
import { Typography, Stack, styled } from "@mui/material";
import { EMPTY_STR } from "@/constants/string";
import Divider from "@mui/material/Divider";
import { black } from "@/theme/colors";

type TMatchInfoItem = {
  label?: string;
  value?: string | null | undefined;
  direction?: "row" | "column";
  isShowDivider?: boolean;
};

export const MatchInfoItem: FCC<TMatchInfoItem> = ({ label, value, direction, isShowDivider = true }) => {
  return (
    <>
      <MatchInfoItemWrapper direction={direction}>
        {label && (
          <Typography
            variant="cap12"
            sx={{
              color: black[70],
              minWidth: direction === "row" ? "100px" : "auto",
              marginBottom: direction === "column" ? "4px" : 0,
              marginRight: direction === "row" ? "8px" : 0,
              flexShrink: 0,
            }}
          >
            {label}
          </Typography>
        )}
        <Typography
          variant="body14Semi"
          sx={{
            color: black[30],
            wordBreak: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
            flex: 1,
          }}
        >
          {value ? value : EMPTY_STR.TEXT}
        </Typography>
      </MatchInfoItemWrapper>
      {isShowDivider && <DividerWrapper />}
    </>
  );
};

const MatchInfoItemWrapper = styled(Stack)<{ direction?: string }>`
  ${({ direction }) =>
    direction === "row"
      ? `
        flex-direction: row;
        align-items: flex-start;
      `
      : `
        flex-direction: column;
      `}
  width: 100%;
`;

const DividerWrapper = styled(Divider)`
  margin: 8px 0;
  width: 100%;
`;
